import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]

import RegisterLoginPopup from '@/view/loginRegister/registerLoginPopup.vue';
import { ref, onMounted, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';

interface TabItem {
    display: boolean,
    title: string,
    default_url: string,
    active_url: string,
    redirectUrl: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'mainFooter',
  props: {
    itemData: {},
    activeFooter: {}
  },
  setup(__props: any, { expose: __expose }) {

const router = useRouter();

const props = __props
const userStore = useUserStore()
const route = useRoute()
const tabList = computed(() => props.itemData.tabs);
const activeFooter = ref(props.activeFooter || 0);
const promoCount = computed(() => userStore.totalMsgListCount);
const registerRef = ref();

const goToPath = (path: string, indexValue: number) => {
    activeFooter.value = indexValue
    router.push(path)
    localStorage.setItem('footerPopupOpen', String(activeFooter.value))
}

const setProfileActiveFooter = () => {
    activeFooter.value = 4
}
const handleHistoryOpenPopup = () => {
    const indexNo: any = localStorage.getItem('footerPopupOpen')
    if (indexNo) {
        goToPath(tabList.value[indexNo].redirectUrl, indexNo)
    } else {
        goToPath(tabList.value[0].redirectUrl, 0)
    }

}
watch(activeFooter, (val) => {
    userStore.setIsInHome(val)
})
onMounted(() => {
    if(!route.query.ref){
      handleHistoryOpenPopup()
    }  
})
__expose({
    setProfileActiveFooter
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_row, {
      class: "footer",
      justify: "space-between",
      style: {"padding-bottom":"5px","padding-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "4",
          class: "footer_item"
        }, {
          default: _withCtx(() => [
            (tabList.value[0].display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "footer_item_container",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPath(tabList.value[0].redirectUrl, 0)))
                }, [
                  (activeFooter.value == 0)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: _normalizeClass({ 'activeImage': activeFooter.value == 0 }),
                        src: tabList.value[0].active_url,
                        alt: ""
                      }, null, 10, _hoisted_1))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: tabList.value[0].default_url,
                        alt: ""
                      }, null, 8, _hoisted_2)),
                  _createElementVNode("div", {
                    class: _normalizeClass(activeFooter.value == 0 ? 'activeClass' : '')
                  }, _toDisplayString(_ctx.$t(tabList.value[0].title)), 3)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "4",
          class: "footer_item"
        }, {
          default: _withCtx(() => [
            (tabList.value[1].display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "footer_item_container",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPath(tabList.value[1].redirectUrl, 1)))
                }, [
                  (activeFooter.value == 1)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: _normalizeClass({ 'activeImage': activeFooter.value == 1 }),
                        src: tabList.value[1].active_url,
                        alt: ""
                      }, null, 10, _hoisted_3))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: tabList.value[1].default_url,
                        alt: ""
                      }, null, 8, _hoisted_4)),
                  _createElementVNode("div", {
                    class: _normalizeClass(activeFooter.value == 1 ? 'activeClass' : '')
                  }, _toDisplayString(_ctx.$t(tabList.value[1].title)), 3)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "4",
          class: "footer_item"
        }, {
          default: _withCtx(() => [
            (tabList.value[2].display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "footer_item_container",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (goToPath(tabList.value[2].redirectUrl, 2)))
                }, [
                  (activeFooter.value == 2)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: _normalizeClass({ 'activeImage': activeFooter.value == 2 }),
                        src: tabList.value[2].active_url,
                        alt: ""
                      }, null, 10, _hoisted_5))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: tabList.value[2].default_url,
                        alt: ""
                      }, null, 8, _hoisted_6)),
                  _createElementVNode("div", {
                    class: _normalizeClass(activeFooter.value == 2 ? 'activeClass' : '')
                  }, _toDisplayString(_ctx.$t(tabList.value[2].title)), 3)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "4",
          class: "footer_item"
        }, {
          default: _withCtx(() => [
            (tabList.value[3].display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "footer_item_container",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (goToPath(tabList.value[3].redirectUrl, 3)))
                }, [
                  (activeFooter.value == 3)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: _normalizeClass({ 'activeImage': activeFooter.value == 3 }),
                        src: tabList.value[3].active_url,
                        alt: ""
                      }, null, 10, _hoisted_7))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: tabList.value[3].default_url,
                        alt: ""
                      }, null, 8, _hoisted_8)),
                  _createElementVNode("div", {
                    class: _normalizeClass(activeFooter.value == 3 ? 'activeClass' : '')
                  }, _toDisplayString(_ctx.$t(tabList.value[3].title)), 3)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "4",
          class: "footer_item"
        }, {
          default: _withCtx(() => [
            (tabList.value[4].display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "footer_item_container",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (goToPath(tabList.value[4].redirectUrl, 4)))
                }, [
                  (activeFooter.value == 4)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: _normalizeClass({ 'activeImage': activeFooter.value == 4 }),
                        src: tabList.value[4].active_url,
                        alt: ""
                      }, null, 10, _hoisted_9))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: tabList.value[4].default_url,
                        alt: ""
                      }, null, 8, _hoisted_10)),
                  _createElementVNode("div", {
                    class: _normalizeClass(activeFooter.value == 4 ? 'activeClass' : '')
                  }, _toDisplayString(_ctx.$t(tabList.value[4].title)), 3)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(RegisterLoginPopup, {
      ref_key: "registerRef",
      ref: registerRef
    }, null, 512)
  ], 64))
}
}

})